export default {
    getCopyType(obj) {
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            return 'Object';
        } else if (Object.prototype.toString.call(obj) === '[object Array]') {
            return 'Array';
        } else {
            return 'nomal';
        }
    },
    deepCopy(obj) {
        if (this.getCopyType(obj) === 'nomal') {
            return obj;
        } else {
            var newObj = this.getCopyType(obj) === 'Object' ? {} : [];
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    newObj[key] = this.deepCopy(obj[key]);
                }
            }
        }
        return newObj;
    }
};



// WEBPACK FOOTER //
// ./src/common/utils/DeepCopy.js